import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import PromoBanner from "./PromoBanner";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ProductCard from "./ProductCard";

const Products = () => {
  const [products, setProducts] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/products")
      .then((res) => res.json())
      .then((data) => {
        setProducts(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return products;
    return products.filter((p) => (p.name || "").toLowerCase().includes(q));
  }, [products, query]);

  return (
    <div className="page">
      <Helmet>
        <title>Collection – Sacs en crochet faits main | Deenzine</title>
        <meta name="description" content="Découvrez toute la collection Deenzine : sacs en crochet faits main, pièces uniques en séries limitées. Plusieurs coloris disponibles, expédition rapide en France." />
        <link rel="canonical" href="https://www.deenzine.com/products" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Deenzine" />
        <meta property="og:locale" content="fr_FR" />
        <meta property="og:url" content="https://www.deenzine.com/products" />
        <meta property="og:title" content="Collection – Sacs en crochet faits main | Deenzine" />
        <meta property="og:description" content="Toute la collection Deenzine : sacs en crochet faits main, séries limitées, plusieurs coloris." />
        <meta property="og:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Collection Deenzine – Sacs en crochet faits main" />
        <meta name="twitter:description" content="Sacs en crochet faits main, séries limitées, plusieurs coloris disponibles." />
        <meta name="twitter:image" content="https://www.deenzine.com/images/og-deenzine.jpg" />
      </Helmet>

      <PromoBanner />
      <Navbar />

      <section className="section">
        <div className="container">
          <div className="card cardPad">
            <h1 className="h2" style={{ color: "var(--brand)", marginBottom: 6 }}>
              Collection
            </h1>
            <p className="p">Recherche rapide par nom.</p>

            <div style={{ display: "flex", gap: 12, marginTop: 16, flexWrap: "wrap" }}>
              <input
                className="input"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Rechercher un modèle…"
                aria-label="Rechercher un modèle"
                style={{ flex: "1 1 260px" }}
              />
              <a className="btn btnSecondary" href="/destockage">
                Dernières pièces
              </a>
            </div>
          </div>

          <div style={{ height: 18 }} />

          {loading ? (
            <div className="card cardPad">Chargement…</div>
          ) : filtered.length === 0 ? (
            <div className="card cardPad">Aucun produit trouvé.</div>
          ) : (
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 18 }}>
              {filtered.map((product) => (
                <ProductCard
                  key={product.id}
                  productId={product.id}
                  image={product.image}
                  name={product.name}
                  price={product.price}
                  promo_price={product.promo_price}
                  promo_active={product.promo_active}
                  colors={product.colors}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Products;
